import { css } from 'linaria';

export const deliveryMethodsWrapper = css`
  border: none;
  border-top: var(--space-10) solid var(--control-minor);
`;
